module.exports = __webpack_public_path__ + "img/reveal-sketch.97bc0f4.jpg";